<template>
  <div class="universities">
    <div class="banner">
      <img
        width="100%"
        :src="headerBannerSrc"
        alt=""
      >
    </div>
    <div class="content">
      <div
        v-for="(section, index) in pageDatas"
        :key="index"
        class="universities-content"
      >
        <h2 class="universities-tit">{{ section.name }}:</h2>
        <ul class="universities-list">
          <li v-for="(item, idx) in section.lists" :key="idx">
            <div class="universities-left">
              <a :href="item.href"><img width="100%" :src="item.banner"></a>
            </div>
            <div class="universities-right">
              <p class="universities-right-tit">
                <img :src="item.icon" alt="">
                <a :href="item.href"><span>{{ item.name }}</span></a>
              </p>
              <p class="universities-right-tip">{{ item.title }}:</p>
              <p class="universities-right-con">{{ item.con }}</p>
              <p class="universities-right-con" v-if="item.time">
                课程时间: <span>{{ item.time }}</span>
              </p>

              <p class="universities-right-option">
                <a
                  v-for="(btn, i) in item.btns"
                  :key="i"
                  :href="btn.url"
                >{{ btn.name }}</a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { os } from '@/utils/index'

const { isPc } = os()
const assetBasicCatalog = isPc ? 'pc' : 'mobile'
const basicSrc = `assets/images/universities/${assetBasicCatalog}`

export default {
  name: 'universities',
  // 引入的组件
  components: {},
  // 混入
  // 当前页面的数据定义
  data() {
    return {
      headerBannerSrc: require(`@/${basicSrc}/head-banner.jpg`),
      pageDatas: [
        {
          name: '高校合作项目',
          lists: [
            {
              banner: require(`@/${basicSrc}/banner-1.jpg`),
              icon: require(`@/${basicSrc}/gxlogo1.png`),
              name: '电子科技大学',
              title: '合作课程',
              href: 'https://mp.weixin.qq.com/s/vzaU_iACkRDVRZgygXF_ew',
              con: '罗布乐思与电子科技大学联合开设《Roblox游戏设计与开发》课程',
              time: '2020年3月-5月',
              // 按钮相关
              btns: [
                { name: '作品展示', url: 'https://dev.robloxdev.cn/experiences' },
                { name: '开发者展示', url: 'https://dev.robloxdev.cn/developers' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-2.jpg`),
              icon: require(`@/${basicSrc}/gxlogo2.png`),
              name: '华中科技大学',
              title: '合作课程',
              href: 'https://mp.weixin.qq.com/s/mdWh2p1jNgrbkVTBqy4w0A',
              con: '罗布乐思与华中科技大学联合开设《游戏学导论》实践课程',
              time: '2020年5月-6月',
              // 按钮相关
              btns: [
                { name: '作品展示', url: 'https://dev.robloxdev.cn/experiences' },
                { name: '开发者展示', url: 'https://dev.robloxdev.cn/developers' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-3.jpg`),
              icon: require(`@/${basicSrc}/gxlogo3.png`),
              name: '北京大学',
              title: '合作课程',
              href: 'https://mp.weixin.qq.com/s/pKwNRTAfagJN9dVsBiJMfQ',
              con: '罗布乐思与北京大学联合开设《游戏化创新思维》课程',
              time: '2020年6月-7月',
              // 按钮相关
              btns: [
                { name: '作品展示', url: 'https://dev.robloxdev.cn/experiences' },
                { name: '开发者展示', url: 'https://dev.robloxdev.cn/developers' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-4.jpg`),
              icon: require(`@/${basicSrc}/gxlogo4.png`),
              name: '上海交通大学',
              title: '合作课程',
              href: 'https://mp.weixin.qq.com/s/D1ahY6omogMUQS4oQuGeXQ',
              con: '罗布乐思与上海交通大学联合开设《腾讯游戏程序开发以及经典案例分析》课程',
              time: '2020年10月-12月',
              // 按钮相关
              btns: [
                { name: '作品展示', url: 'https://dev.robloxdev.cn/experiences' },
                { name: '开发者展示', url: 'https://dev.robloxdev.cn/developers' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-5.jpg`),
              icon: require(`@/${basicSrc}/gxlogo5.png`),
              name: '中央美术学院',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/inLbZDE8e5q0TnIriw_CeA',
              con: '罗布乐思与中央美术学院联合开设《游戏原型设计及迭代》课程',
              time: '2021年3月-4月',
              // 按钮相关
              btns: [
                { name: '作品展示', url: 'https://dev.robloxdev.cn/experiences' },
                { name: '开发者展示', url: 'https://dev.robloxdev.cn/developers' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-6.jpg`),
              icon: require(`@/${basicSrc}/gxlogo6.png`),
              name: '上海交大罗布乐思俱乐部',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/GVTLFefBWriPbYw7yT1dEQ',
              con: '罗布乐思携手上海交通大学成立罗布乐思俱乐部',
              time: '',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://mp.weixin.qq.com/s/GVTLFefBWriPbYw7yT1dEQ' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-7.jpg`),
              icon: require(`@/${basicSrc}/gxlogo7.png`),
              name: '华南理工大学',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/2hS8ESIiKIkEMFf6itkC4g',
              con: '罗布乐思与华南理工大学合作线上讲座',
              time: '2020年11月26日',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://mp.weixin.qq.com/s/2hS8ESIiKIkEMFf6itkC4g' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-8.jpg`),
              icon: require(`@/${basicSrc}/gxlogo8.png`),
              name: '北京国际游戏创新科技展&中国传媒大学',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/qVFI4WItJp1dT8J021YExQ',
              con: '罗布乐思受邀参与由中国传媒大学承办，中共北京市委宣传部指导的北京国际游戏创新科技展',
              time: '2020年9月25日-2020年9月29日',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://mp.weixin.qq.com/s/qVFI4WItJp1dT8J021YExQ' }
              ]
            }
          ]
        },
        {
          name: '教育部合作项目',
          lists: [
            {
              banner: require(`@/${basicSrc}/banner-9.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: '腾讯游戏学院&罗布乐思游戏设计与开发研习营',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/LmgEmsFnYi3zkZBOUs_gwg',
              con: '本活动由教育部高等学校动画、数字媒体专业教学指导委员会、全国高等院校计算机基础教育研究会主办，中国传媒大学动画与数字艺术学院、腾讯游戏学院和罗布乐思承办，面向全国相关专业高校教师授课。',
              time: '2020年11月',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://mp.weixin.qq.com/s/LmgEmsFnYi3zkZBOUs_gwg' }
              ]
            }
          ]
        },
        {
          name: '腾讯游戏学院合作项目',
          lists: [
            {
              banner: require(`@/${basicSrc}/banner-10.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: '花火计划',
              title: '合作内容',
              href: 'https://gameinstitute.qq.com/minigame',
              con: '罗布乐思大学生作品入选腾讯游戏学院花火计划',
              time: '',
              // 按钮相关
              btns: [
                { name: '作品展示一', url: 'https://gameinstitute.qq.com/minigame/10091' },
                { name: '作品展示二', url: 'https://gameinstitute.qq.com/minigame/10090' },
                { name: '作品展示三', url: 'https://gameinstitute.qq.com/minigame/10104' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-11.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: 'Weplay文化展',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/PMkg84vK4RGhl4uiKHCKwg',
              con: '腾讯游戏学院携手罗布乐思参与上海Weplay游戏展本次赛事由腾讯游戏学院发起，是一个面向全球游戏开发者的年度赛事，旨在搭建一个开放的游戏创意合作平台。期望连接全球的优秀创意，汇集国内外知名专家为其打磨品质，助力优质游戏腾飞，助推行业良性发展，向全球宣传创意游戏的价值。',
              time: '2020年11月15日',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://mp.weixin.qq.com/s/PMkg84vK4RGhl4uiKHCKwg' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-12.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: '工程实训大赛',
              title: '合作内容',
              href: 'https://gameinstitute.qq.com/college/engineering-competition/',
              con: 'Roblox是全国大学生工程训练大赛官方推荐的编辑器之一。全国大赛的优秀作品将有机会获得罗布乐思官方的签约机会，若签约，将获得独立于大赛的Roblox专项扶持金3万元与长期的培养孵化。',
              time: '2020年9月-2021年6月',
              // 按钮相关
              btns: [
                { name: '赛项展示', url: 'https://gameinstitute.qq.com/college/engineering-competition/' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-13.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: '腾讯高校游戏创意制作大赛',
              title: '合作内容',
              href: 'https://mp.weixin.qq.com/s/ddTbacJ752ISD5ywFqx0cQ',
              con: '由腾讯游戏学院主办，旨在通过游戏创意制作过程及作品产出发掘高校优秀的游戏研发人才和创意作品，给学生一个展示自己的舞台，发掘、培养并孵化游戏人的创意，打造属于高校游戏人自己的赛事。',
              time: '2020年11月23日',
              // 按钮相关
              btns: [
                { name: '赛项展示', url: 'https://mp.weixin.qq.com/s/ddTbacJ752ISD5ywFqx0cQ' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-14.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: 'GWB腾讯游戏创意大赛',
              title: '合作内容',
              href: 'https://gwb.tencent.com/awards2020/zone/roblox',
              con: '罗布乐思（Roblox）联合腾讯游戏创意大赛专门设立罗布乐思游戏作品赛区，挖掘国内优秀开发者，为优秀作品提供流量扶持、市场宣传和资金扶持，助力国内开发者的创意作品获得全球玩家的认可。',
              time: '',
              // 按钮相关
              btns: [
                { name: '赛项展示', url: 'https://gwb.tencent.com/awards2020/zone/roblox' }
              ]
            },
            {
              banner: require(`@/${basicSrc}/banner-15.jpg`),
              icon: require(`@/${basicSrc}/gxlogo9.png`),
              name: '腾讯游戏学院罗布乐思夏令营',
              title: '合作内容',
              href: 'https://gameinstitute.qq.com/articles/759331.html',
              con: '腾讯游戏学院“科技向善”夏令营在深圳举办，来自全国1 5所重点高等院校的51名优秀大学生相聚在腾讯，展开了-场科技+文化+ 公益+ 12小时极限开发营的精彩之旅 。',
              time: '2019年7月25日-2019年7月28日',
              // 按钮相关
              btns: [
                { name: '精彩回顾', url: 'https://gameinstitute.qq.com/articles/759331.html' }
              ]
            }
          ]
        }
      ]
    }
  },
  // 计算属性
  computed: {},
  // 页面初始化的时候执行的方法
  created() {},
  // html已经渲染并挂载后的执行方法
  mounted() {}
  // 当前页面的方法集合
  // methods: {
  //   handleClickProduction() {
  //     console.log()
  //     window.href = `https://dev.robloxdev.cn/experiences`
  //   },
  //   handleClickDeveloper() {
  //     window.href = `https://dev.robloxdev.cn/developers`
  //   }
  // }
}
</script>

<style lang="scss" scope>
.universities {
  .content{
    padding-top: 100PX;
  }
  .universities-tit {
    padding-top: 0PX;
    padding-bottom: 65PX;
    font-size: 32PX;
    line-height: 100%;
    color: #fff;
  }
  .universities-content {
    text-align: left;
    margin: 0 auto;
    width: 1250PX;
    color: #fff;
    box-sizing: border-box;
  }
  .universities-list {
    li {
      margin-bottom: 108PX;
      padding: 35PX 42PX;
      align-items: center;
      // height: 320PX;
      background-color: #0d0d0d;
      display: flex;

      .universities-left {
        float: left;
        width: 410PX;
        // height: 100%;
        height: 250PX;
        position: relative;
        flex-grow: 0;

        img{
          position: absolute;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
      .universities-right {
        // margin-left: 520PX;
        margin-left: 100PX;
        width: 50%;
        height: 100%;
        font-size: 16PX;
        line-height: 100%;
        flex-grow: 1;

        &-tit {
          height: 86PX;
          line-height: 86PX;
          font-size: 24PX;

          span {
            margin-left: 28PX;
            color: #fff;
          }
        }

        &-tip {
          margin-top: 28PX;
        }

        &-con {
          margin-top: 20PX;
          color: #ccc;
          line-height: 24PX;
        }

        &-option {
          margin-top: 20PX;

          a {
            margin-right: 20PX;
            display: inline-block;
            vertical-align: middle;
            padding-bottom: 5PX;
            border-bottom: 1px solid  #fff;
            color: #fff;
          }
        }
      }
    }
  }
}
.foot_dark,.foot_links .link_map span, .foot_links .link_map a,.foot_dark a{
	color: #C0C0C0 !important;
}

@media screen and (max-width: 800px) {
  .universities {
    .content{
      padding-top: 100px;
    }
    .universities-tit {
      padding-top: 0;
      padding-bottom: 94px;
      font-size: 40px;
    }

    .universities-content {
      width: 100%;
      padding: 0 30px;
    }

    .universities-list {
      li {
        margin-bottom: 100px;
        padding: 34px;
        padding-top: 0;
        height: 100%;
        flex-wrap: wrap;

        .universities-left {
          width: 100%;
          height: 364px;
          float: inherit;

          img {
            height: 100%;
          }
        }
        .universities-right {
          margin-left: 0;
          height: auto;
          font-size: 14PX;
          line-height: 100%;

          &-tit {
            margin-top: 35px;
            height: 82px;
            line-height: 82px;
            font-size: 30px;

            img {
              width: 82px;
              height: 82px;
            }

            span {
              margin-left: 20px;
            }
          }

          &-tip {
            margin-top: 35px;
          }

          &-con {
            margin-top: 20px;
            line-height: 40px;
          }

          &-option {
            margin-top: 45px;

            a {
              margin-right: 20px;
              padding-bottom: 5px;
            }
          }
        }
      }
    }
  }
}
.foot, .afooter{
	color: #C0C0C0 !important;
}

.foot_dark .foot_ieg_logo {
        background: url(https://kude.oss-cn-hangzhou.aliyuncs.com/imgs/basepics/tencentlogoop.png) !important;
        background-repeat: no-repeat !important;
        width: 398PX !important;
		}
		.m-logo{
			display: none;
		}
		.foot_links .link_map span, .foot_links .link_map a, .foot_dark a, .foot_links .copyright_txt{
			color: #bdbebe !important;
		}
		@media screen and (max-width: 800px){
			.m-logo {
          display: block;
          background: #0d0d0d;
          padding: .5rem 0 0 0;
			}
			.m-logo>img {
          display: block;
          width: 3.81rem;
          height: .3rem;
          margin: 0 auto;
			}
			.foot {
          font-size: .22rem;
          text-align: center;
          padding: .5rem 0;
          background: #0d0d0d;
          color: #bdbebe;
			}
		}
</style>
